export enum ServiceTimeClass {
    Day = 'Day',
    Hour = 'Hour',
    Month = 'Month',
    Night = 'Night',
}
